import Breadcrumb from './../components/BreadCrumb';
import Posts from './../sections/LatestPost';
import HeadingDetailsSection from './../sections/HeadingDetailsSection';
import BlogDetailCard from './../components/BlogDetailCard';
import Property from './../assets/pexels/copyright.jpg'


function Blog2Screen() {
  return (
    <>
      <HeadingDetailsSection heading="Blog">
        <Breadcrumb parent="Blog" screen="How to Protect Your Intellectual Property" />
      </HeadingDetailsSection>

      {/* Main Content Layout - Flex for splitting between BlogDetailSection and Posts */}
      <div className="flex flex-col lg:flex-row mb-10">
        {/* Blog Detail Section - Takes 2/3 of the width */}
        <div className="lg:w-2/3 w-full border-none">
          <BlogDetailCard 
            heading="How to Protect Your Intellectual Property"
            image={Property}
            description="Compliance is crucial for growing businesses as it ensures adherence to legal and regulatory standards, helping to avoid costly penalties, legal issues, and reputational damage. By prioritizing compliance, businesses build trust with customers, protect sensitive data, and improve operational efficiency. It opens doors to new markets, attracts investment, and safeguards the company’s reputation and financial integrity. Compliance also fosters a safe work environment for employees and reduces the risk of disruptions, enabling businesses to scale sustainably while maintaining a positive public image and ensuring long-term success."
          />
        </div>

        {/* Posts Section - Takes 1/3 of the width (Visible only on medium screens and larger) */}
        <div className="lg:w-1/3 w-full border-none hidden lg:block">
          <div className="sticky top-0 h-screen"> {/* This makes the posts section sticky */}
            <Posts />
          </div>
        </div>
      </div>
    </>
  );
}

export default Blog2Screen;
